"use strict";

module.exports = {
    Single: require("./select_list/single/SingleSelectListControlComponent"),
    Multiple: require("./select_list/multiple/MultipleSelectListControlComponent"),
    FilterableMultiple: require("./select_list/multiple/FilterableMultipleSelectListControlComponent"),
    Icon: {
        Single: require("./select_list/icon_single/IconSingleSelectListControlComponent"),
        Multiple: require("./select_list/icon_multiple/IconMultipleSelectListControlComponent"),
    },
};
